import React, { useState } from 'react';
import { loginUser } from '../firebase';
import { LogoMark } from '../components/Logo';

export default function Login({ onSwitch, onHome }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try { await loginUser(email, password); }
    catch (err) { setError('Invalid email or password. Please try again.'); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(160deg, #0a3d2e 0%, #0f6e56 50%, #1d9e75 100%)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <LogoMark dark />
        </div>

        <div style={{ background:'white', borderRadius:20, padding:36, boxShadow:'0 24px 64px rgba(0,0,0,0.18)' }}>
          <div style={{ fontSize:18, fontWeight:600, color:'#222', marginBottom:6 }}>Welcome back</div>
          <div style={{ fontSize:13, color:'#888', marginBottom:24 }}>Sign in to your FinlyBooks account</div>

          <form onSubmit={handleLogin}>
            <Field label="Email address" type="email" value={email} onChange={setEmail} placeholder="you@business.com" />
            <Field label="Password" type="password" value={password} onChange={setPassword} placeholder="••••••••" />
            {error && <ErrBox msg={error} />}
            <button type="submit" disabled={loading} style={btnStyle('#0f6e56')}>
              {loading ? 'Signing in...' : 'Sign in →'}
            </button>
          </form>

          <div style={{ textAlign:'center', marginTop:20, fontSize:13, color:'#888' }}>
            Don't have an account?{' '}
            <button onClick={onSwitch} style={{ background:'none', border:'none', color:'#0f6e56', fontWeight:600, cursor:'pointer', fontSize:13 }}>
              Create free account
            </button>
          </div>
        </div>

        <div style={{ textAlign:'center', marginTop:20, fontSize:11, color:'rgba(255,255,255,0.35)' }}>
          © 2025 FinlyBooks · info@finlybooks.com · www.finlybooks.com
        </div>
        {onHome && <div style={{ textAlign:'center', marginTop:12 }}><button onClick={onHome} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontSize:13 }}>← Back to home</button></div>}
      </div>
    </div>
  );
}

function Field({ label, type='text', value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom:16 }}>
      <label style={{ display:'block', fontSize:12, fontWeight:500, color:'#555', marginBottom:6, textTransform:'uppercase', letterSpacing:0.5 }}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required
        style={{ width:'100%', padding:'12px 14px', border:'1px solid #e0e0e0', borderRadius:10, fontSize:14, color:'#222', outline:'none', background:'#fafafa', transition:'border 0.15s' }}
        onFocus={e => e.target.style.borderColor='#0f6e56'}
        onBlur={e => e.target.style.borderColor='#e0e0e0'}
      />
    </div>
  );
}

function ErrBox({ msg }) {
  return <div style={{ background:'#fcebeb', color:'#a32d2d', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:16, borderLeft:'3px solid #a32d2d' }}>{msg}</div>;
}

function btnStyle(color) {
  return { width:'100%', padding:'13px', background:color, color:'#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:600, cursor:'pointer', letterSpacing:0.3 };
}
